import { IsDateString, IsString, IsOptional, IsArray, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { MatchDto } from './match.dto';

export class SlateSegmentDto {
	id: number;

	@IsDateString()
	startDate: string;

	@IsDateString()
	endDate: string;

	@IsOptional()
	@IsString()
	roundGroup?: string;
}

export class getSlatesDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => SlateSegmentDto)
	segments: SlateSegmentDto[];

	@IsString()
	eventId: string;

	@IsString()
	groupId: string;
}

export class SlateByEventDto {
	id: string;
	name: string;
	opening_date?: Date | string | null;
	closing_date?: Date | string | null;
	order: number;
	group_name?: string | null;
	matches: MatchDto[];
}
